export default {
  isAuthenticated: (state) => {
    return state.user != null;
  },
  getUser: (state) => {
    return state.user;
  },
};
